<template>
    <div>
        <br>
        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>เลขที่ใบ PO</label>
            </b-col>
            <b-col sm="6">
                <input class="form-control"
                       v-model="form.po_number"
                       disabled/>
            </b-col>
        </b-row>
        <br>
        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>วันที่ออกใบ PO</label>
            </b-col>
            <b-col sm="6">
                <input class="form-control"
                       type="date"
                       v-model="form.date" disabled
                />
            </b-col>
        </b-row>
        <br>
        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>ยอดเงิน</label>
            </b-col>
            <b-col sm="6">
                <input class="form-control"
                       type="text"
                       v-model="form.total" disabled
                />
            </b-col>
        </b-row>
        <br>
        <b-row sm="10" v-if="form.user">
            <b-col sm="4" class="col text-right">
                <label>ผู้จัดทำใบ PO</label>
            </b-col>
            <b-col sm="6">
                <input type="text"
                       class="form-control"
                       v-model="form.user.name" disabled
                />
            </b-col>
        </b-row>
        <br>
        <b-row sm="10" v-if="form.vendor">
            <b-col sm="4" class="col text-right">
                <label>ผู้จำหน่าย</label>
            </b-col>
            <b-col sm="6">
                <input type="text"
                       class="form-control"
                       v-model="form.vendor.name" disabled
                />
            </b-col>
        </b-row>
        <br>
        <div class="text-center">
            <b-form-group>
                <b-form-radio-group
                        v-model="form.status"
                        :options="optionsPO"
                        name="radioInline">
                </b-form-radio-group>
            </b-form-group>
        </div>
        <div class="text-center">
            <div v-if="form.vendor && form.vendor.quotation">
                <span v-if="form.vendor.quotation.length < 1" style="margin-top: 2vh;" >
                <a disabled="true" style="color: #6b6b6b"><icon name="file-alt" style="width: 25px"></icon>ดูใบเสนอราคา</a>
            </span>
                <span v-else style="margin-top: 2vh;" >
                <a :href="form.vendor.quotation[0].path_img" target="_blank"><icon name="file-alt" style="width: 25px"></icon>ดูใบเสนอราคา</a>
            </span>
                &nbsp;<span style="margin-top: 2vh;">
                <router-link to="SB_List" target="_blank"><icon name="shopping-bag" style="width: 25px"></icon>ดูรายการเช็คถุง</router-link>
             </span>
            </div>
        </div>
        <br><br>
        <b-row>
            <div class="col text-center">
                <button type="button"
                        @click="submitData"
                        class="btn btn-success">
                    <icon name="save" style="width: 25px"></icon> บันทึก</button>&nbsp&nbsp
                <button type="button"
                        @click="submitCancel"
                        class="btn btn-outline-secondary">
                    <icon name="times" style="width: 25px"></icon> ยกเลิก
                </button>
            </div>
        </b-row>
        <br>
        <!--<pre class="alert alert-primary">{{ form }}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import InvoiceModal from "../../Order/Invoice/InvoiceStatusModal";
    import InputGroup from "bootstrap-vue/es/components/input-group/input-group";
    export default {
        components: {
            InputGroup,
            InvoiceModal},
        name: "edit-purchase-order-modal",
        data(){
            return {
                optionsPO: [
                    { text: 'รอการอนุมัติ', value: 1 },
                    { text: 'อนุมัติแล้ว', value: 2 },
                ]
            }
        },
        computed:{
            ...mapState({
                form :state =>{
                    return state.PurchaseOrder.form;
                }
            })
        },
        methods:{
            submitData(){
                this.$emit('submit',this.form);
            },
            submitCancel(){
                this.$emit('submit','cancel');
            }
        }
    }
</script>

<style scoped>

</style>